import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./pagesStyles/LoginPage.css";
import kouLogo from "../images/koulogo.png";
import api from "../services/api";

function LoginPage() {
  const [sicilNo, setSicilNo] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // debug=1 ile çağır
      const response = await api.post("/auth/login", { sicilNo, password }, { params: { debug: 1 } });

      // Debug header'ları
      try {
        const ldapEndpoint = response.headers?.["x-ldap-endpoint"];
        const ldapAttempted = response.headers?.["x-ldap-attempted"];
        if (ldapEndpoint || ldapAttempted) {
          // sadece konsola yaz
          // eslint-disable-next-line no-console
          console.log("LDAP endpoint:", ldapEndpoint, "attempted:", ldapAttempted);
        }
      } catch {}

      if (response.data.success) {
        const userType = response.data.user.type;
        const token = response.data.token;         // NEW
        const expiresAt = response.data.expiresAt; // NEW (ms)

        if (token) {
          localStorage.setItem("token", token);
          if (expiresAt) localStorage.setItem("tokenExpiresAt", String(expiresAt));
          // Set default Authorization header for future requests
          api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        }

        localStorage.setItem("user", JSON.stringify(response.data.user));
        switch (userType) {
          case "admin": navigate("/AdminHomePage"); break;
          case "student": navigate("/StudentHomePage"); break;
          case "unit": navigate("/UnitHomePage"); break;
          default: setError("Bilinmeyen kullanıcı tipi");
        }
      }
    } catch (error) {
      const status = error.response?.status;
      const msg =
        status === 401 ? "Kullanıcı adı veya şifre hatalı."
        : status === 502 ? "LDAP servisine ulaşılamadı."
        : status === 504 ? "LDAP zaman aşımı. Tekrar deneyin."
        : (error.response?.data?.message || "Giriş yapılırken hata oluştu");
      setError(msg);

      // Header'ları hata durumunda da konsola yaz
      try {
        const ldapEndpoint = error.response?.headers?.["x-ldap-endpoint"];
        const ldapAttempted = error.response?.headers?.["x-ldap-attempted"];
        if (ldapEndpoint || ldapAttempted) {
          // eslint-disable-next-line no-console
          console.log("LDAP endpoint:", ldapEndpoint, "attempted:", ldapAttempted);
        }
      } catch {}
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <img src={kouLogo} alt="Kou Logo" className="login-logo" />
        
        <form onSubmit={handleLogin}>

          <div className="login-info">
          <p>Mailinizin @ işaretinden önceki kısmını giriniz.</p>
          </div>


          <div className="input-group">
            <label htmlFor="Username" className={sicilNo ? "filled" : ""}>
              Öğrenci/Personel<span className="required-star">*</span>
            </label>
            <input
              type="text"
             id="Username"
              value={sicilNo}
              onChange={(e) => setSicilNo(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="Password" className={password ? "filled" : ""}>
              Mail Şifresi<span className="required-star">*</span>
            </label>
            <input
              type="password"
              id="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="button-group">
            <button 
              type="submit" 
              className="login-button"
              disabled={loading}
            >
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </div>

        </form>
              <div className="forgot-password-container">
        <p className="forgot-password-text">
          Şifre bilgilerinizi hatırlamıyorsanız{" "}
          <a 
            href="https://portal.kocaeli.edu.tr/emailogr/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="forgot-password-link"
          >
            buradan
          </a>{" "}
          şifrenizi sıfırlayabilirsiniz.
        </p>
      </div>
      </div>
    </div>
  );
}

export default LoginPage;